import Api from "../common/Api";
import {PpaRqsModel} from "../cb/PpaRqsModel";


export class PpaRqsService extends Api {

  private static service: PpaRqsService;

  private static PPA_RQS_INSERT_URL: string = process.env.REACT_APP_URL_RP + '/ppa-rqs';
  private static PPA_NGTN_INSERT_URL: string = process.env.REACT_APP_URL_RP + '/ppa-rqs/ngtn';
  private static PPA_NGTN_DETAIL_URL: string = process.env.REACT_APP_URL_RP + '/ppa-rqs/detail';
  private static PPA_NGTN_DETAIL_STATUS: string = process.env.REACT_APP_URL_RP + '/ppa-rqs/status';
  private static PCHID_AND_STATUS_URL: string = process.env.REACT_APP_URL_RP + '/ppa-rqs/pchsrIdAndStatus';
  private static CNTR_PWPL_COUNT: string = process.env.REACT_APP_URL_RP + '/ppa-rqs/cntrPwplCount';

  public static getInstance(): PpaRqsService {
    if (!PpaRqsService.service) {
      PpaRqsService.service = new PpaRqsService();
    }
    return PpaRqsService.service;
  }

  public async insertMatchingPpaRqs(form: PpaRqsModel) {
    return await super.post<PpaRqsModel>(PpaRqsService.PPA_RQS_INSERT_URL, form)
  }

  public async insertMatchingPpaNgtn(form: PpaRqsModel) {
    return await super.post<PpaRqsModel>(PpaRqsService.PPA_NGTN_INSERT_URL, form)
  }

  public async getPpaNgtn(ngtnId: string) {
    return await super.get<any>(PpaRqsService.PPA_NGTN_DETAIL_URL,{ppaRqsId:ngtnId})
  }

    public async putPpaNgtn(requestStatus: any) {
    return await super.put<any>(PpaRqsService.PPA_NGTN_DETAIL_STATUS,requestStatus)
  }

  public async updatePpaRqsStatus(rqsId: string, cntrPrstsCd: number) {
    return await super.put<PpaRqsModel>(PpaRqsService.PPA_NGTN_DETAIL_STATUS, {
      ppaRqsId: rqsId, emksCntrPrgsStsCd: cntrPrstsCd});
  }
  public async getPchsrIdAndStatus() {
    return await super.get<any>(PpaRqsService.PCHID_AND_STATUS_URL);
  }

  public async getCntrPwplCount() {
    return await super.get<any[]>(PpaRqsService.CNTR_PWPL_COUNT)
  }
}